import { instance } from "libs/api";

import { ApiRoutesEmailNotifications } from "../../constants";

export const requestRemoveEmailRecipient = async (
  recipientId: string
): Promise<{ success: boolean }> => {
  return await instance.delete(
    `${ApiRoutesEmailNotifications.Recipients}/${recipientId}`
  );
};
